<script setup lang="ts">
defineProps<{
  value: number;
  steps: number[];
}>();
</script>

<template>
  <div class="progress-container">
    <ion-progress-bar v-bind="$attrs" :value="value" />
    <div class="step-indicators" v-if="steps?.length">
      <div
        v-for="step in steps"
        :key="step"
        class="step-dot"
        :class="{ 'opacity-0': step === 0 || step === steps.length - 1, 'bg-white': +step / 5 <= +value }"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/scss/setup/_variables.scss';
@import '@/scss/setup/_functions.scss';

.progress-container {
  position: relative;
  width: 100%;
}

ion-progress-bar {
  --background: transparent;
  height: toRem(5px);
  box-shadow: none;
  outline: 1px solid $color-medium-light;
  border-radius: toRem(20px);

  &::part(progress) {
    border-radius: toRem(20px);
  }
}

.step-indicators {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 toRem(2px);
}

.step-dot {
  width: toRem(2px);
  height: toRem(2px);
  background-color: var(--ion-color-medium-light);
  border-radius: 50%;
  z-index: 1;
  &.bg-white {
    background-color: white;
  }
}
</style>
